<template>
    <div id="app">
        <el-container>
            <el-header class="div-header">
                <Header />
                <el-divider class="header-divider"></el-divider>
            </el-header>
            <div class="main-div">
                <el-container class="parentDiv">
                    <splitpanes class="default-theme defaultStyle custom-splite">
                        <pane size="100" class="SideBarLeft">
                            <div class="SID0012_DivMainCompoment">
                                <!-- Breadcrumb section -->
                                <section>
                                    <el-breadcrumb separator-class="el-icon-arrow-right" class="SearchRegisterLink">
                                        <el-breadcrumb-item :to="{ path: '0002' }">トップ(記事一覧)</el-breadcrumb-item>
                                        <el-breadcrumb-item :to="{ path: '0011' }">検索条件一覧</el-breadcrumb-item>
                                        <el-breadcrumb-item :to="{ path: '' }">検索条件登録</el-breadcrumb-item>
                                    </el-breadcrumb>
                                </section>

                                <!-- Nested form section -->
                                <section class="FormTopSection">
                                    <el-form ref="formitem" :rules="rules"  :model="formitem" label-width="auto">
                                        <el-form-item label="タイトル(必須)" class="inputLableRequired" prop="input1" v-if="showtitle == 1">
                                            <el-input v-model="formitem.input1" class="InputTitleRequired"></el-input>
                                        </el-form-item>
                                         <el-form-item label="タイトル(必須)" class="inputLableRequired" prop="input1" v-else>
                                            <el-input v-model="formitem.input1" readonly class="InputTitleRequired"></el-input>
                                        </el-form-item>
                                    </el-form>  
                                        <el-form ref="form" :rules="rules" :model="form"  class="nestedFormSection" label-width="auto">
                                            <el-row  class="toptitle_css">
                                                <el-col :span="8" :offset="0">
                                                    <span>キーワード検索条件</span>
                                                </el-col>
                                            </el-row>
                                            <el-form-item label="キーワード1" class="FormNestedLable" prop="input2">
                                                <el-input v-model="form.input2" class="InputTitleRequiredMiddle"></el-input>
                                            </el-form-item>
                                             <el-form-item prop="value1" class="select__">
                                                  <label class="RedColorMandatory1">*</label>
                                                <el-select
                                                    v-model="form.value1"
                                                    @change="handleChange($event)"
                                                    class="formSelectOption">
                                                    <el-option
                                                    v-for="item in getOptionFirst0012"
                                                    :key="item.value"
                                                    :label="item.label"
                                                    :value="item.value">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item label="キーワード2" class="FormNestedLable" prop="input3">
                                                <el-input v-model="form.input3" class="InputTitleRequiredMiddle"></el-input>
                                            </el-form-item>
                                        </el-form>
                                </section>

                                <!-- Dropdown option section -->
                                <section class="SelectMiddleOption">
                                    <div >
                                        <label class="RedColorMandatory">*</label>
                                        <el-select
                                        v-model="form.value2"
                                         @change="handleChange1($event)"
                                        class="formSelectOptionMiddle">
                                        <el-option
                                        v-for="item in getOptionSecond0012"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                        </el-option>
                                        </el-select>    
                                    </div>
                                </section>

                                <!-- Dynamically add or remove input textbox section -->
                                <section class="FormTopSection">
                                    <el-form  v-if="getmediaNameForm.items != undefined && getmediaNameForm.items.length > 0" ref="mediaNameForm" :model="getmediaNameForm" label-width="auto" class="DynamicFormInput">
                                        <el-row class="toptitle_css_bottom">
                                                <span>{{ getsearchTopic0012 }}</span>                                      
                                        </el-row>
                                        <div class="formGroup"  v-for="(input,k) in getmediaNameForm.items" :key="k" >
                                            <el-form-item class="inner__form" :label="input.label"  
                                                :prop="'items.' + k + '.name'"
                                                :rules="[{ max: 100, message: '媒体名は100文字以下で入力してください', trigger: 'blur'}]">
                                                <el-input type="text" class="form-control" v-model="input.name"></el-input>
                                                <span class="formGroupIcon">
                                                    <i class="fas fa-minus-circle" @click="editFormRemove(k)" v-show="k || ( !k && getmediaNameForm.items.length > 1)"></i>
                                                    <i class="fas fa-plus-circle" @click="editFormAdd(k)" v-show="((k == getmediaNameForm.items.length-1) && (getmediaNameForm.items.length !== 5))"></i>
                                                </span>
                                            </el-form-item>
                                        </div>
                                    </el-form>
                                    <el-form v-if="this.$route.params.editToken == undefined || this.$route.params.editToken == '' " ref="mediaNameForm" :model="mediaNameForm" label-width="auto" class="DynamicFormInput">
                                        <el-row class="toptitle_css_bottom">
                                                <span>{{ getsearchTopic0012 }}</span>                                      
                                        </el-row>
                                        <div class="formGroup" v-for="(input,k) in mediaNameForm.items" :key="k">
                                            <el-form-item class="inner__form" :label="input.label"
                                                :prop="'items.' + k + '.name'"
                                                :rules="[{ max: 100, message: '媒体名は100文字以下で入力してください', trigger: 'blur'}]">
                                                <el-input type="text" class="form-control" v-model="input.name"></el-input>
                                                <span class="formGroupIcon">
                                                    <i class="fas fa-minus-circle" @click="removeNew(k)" v-show="k || ( !k && mediaNameForm.items.length > 1)"></i>
                                                    <i class="fas fa-plus-circle" @click="addNew(k)" v-show="((k == mediaNameForm.items.length-1) && (mediaNameForm.items.length !== 5))"></i>
                                                </span>
                                            </el-form-item>
                                        </div>
                                    </el-form>
                                </section>
                                <el-row class="ButtonClearInput">
                                    <!-- // 2023/03/27  #14161  START -->
                                    <el-button type="primary" plain @click="register('formitem')" :disabled="Buttonpressed == 1">登録</el-button>
                                    <!-- // 2023/03/27  #14161  END -->
                                    <el-button type="info" plain @click="clear_input('form', 'formitem')">お試し検索</el-button>
                                    <el-button type="info" plain @click="gotoback('mediaNameForm')">戻る</el-button>
                                </el-row>
                            </div>
                        </pane>
                        <pane class="SideBarRight">
                            <SideBar class="SidePane" />
                        </pane>
                    </splitpanes>
                </el-container>
            </div>
            <el-container class="footer-div">
                <el-footer class="footer-element">
                    <FooterComponent />
                </el-footer>
            </el-container>
        </el-container>
    </div>
</template>

<script>
import Header from "../common/header.vue";
import SideBar from "../common/side-bar.vue";
import FooterComponent from "../common/footerComponent.vue"; 
import { mapGetters } from "vuex";
import { Splitpanes, Pane } from "splitpanes";
import "splitpanes/dist/splitpanes.css";
import router from '../../router';
import json from '../../components/config.json'
import Vue from "vue";
export default {
    name: "SearchConditionRegister",
    components: {
        Header,
        SideBar,
        FooterComponent,
        Splitpanes,
        Pane
    },
    data() {
        return {
            // 2023/03/27  #14161  START
            Buttonpressed: 0,
            // 2023/03/27  #14161  END
            MediaAlert:'',
            showtitle: '',
            showoperator:'',
            showmediaoperator:'',
            formitem:{
                 input1: '',
            },
            form:{
                input2: '',
                input3: '',
                value:'',
                name:'',
                value1:'AND',
                value2: 'AND'
            },
            formgroup:{
                value:'',
                key:'',
                input:'',
                name:''
            },
            rules: {
                input1: [
                    { required: true, message: 'タイトルを入力してください。'},
                    { max: 100, message: 'タイトルは100文字以下で入力してください'},
                    /*** Change by BM for backlog Id: 1634 to remove full width symbols from the pattern and reverted*/
                    /***2021/04/20  #10821  START*/
                   /***{ pattern:/^[\u3040-\u30ff\u3400-\u4dbf\u4e00-\u9fff\uf900-\ufaff\uff66-\uff9f\uff00-\uffefa-zA-Z0-9 ]+$/,message:'タイトルは記号以外を入力してください。'}*/
                    { pattern:/^[\u2000-\u206f\u2600-\u26ff\u2000-\u206f\u25a0-\u25ff\u3000-\u30ff\u3400-\u4dbf\u4e00-\u9fff\uf900-\ufaff\uff00-\uffeea-zA-Z0-9]+$/,message:'タイトルは記号以外を入力してください。'}
                    /***2021/04/20  #10821  END*/
                ],
                value1: [
                    { required: true, message: 'タイトルを入力してください。', trigger: 'change'},
                ],
                input2: [
                    {max: 500, message: 'キーワード1には500文字以下で入力してください。', trigger: 'change'}
                ],
                input3: [
                    { max: 500, message: 'キーワード2には500文字以下で入力してください。', trigger: 'change'}
                ],
                getOptionFirst0012: [
                    { max: 100, message: 'メディア名は100文字以下で入力してください'}
                ],
                value:[{requird:true, message:'need'},{max:2, message:'length'}],
                key:[{requird:true, message:'need'},{max:2, message:'length'}],
                input:[{requird:true, message:'need'},{max:2, message:'length'}],
                name:[{requird:true, message:'need'},{max:2, message:'length'}]
            },
            inputs:[{
                label:'媒体名1',
                name:''
            }],
            mediaNameForm: {
                items: [{
                    label:'媒体名1',
                    name:''
                }]
            },
            userId:'',
            contractId:'',
            theme_browsing:false,   
            service_linkage_info:[]
           
        }    
    },
    computed: {
        ...mapGetters("situation0012", [
            "getOptionFirst0012",
            "getOptionSecond0012",
            "getsearchTopic0012",
            "gettitle",
            "getkeyword",
            "getoperator",
            "getkeywordTwo",
            "getmediaOperator",
            "getfirstIndex",
            "getregisterform",
            "getmessagecode",
            "getmessageDetail",
            "getmediaNameForm"
        ]),
        ...mapGetters("validationHandler", [
            "getRules",
        ]),
        ...mapGetters("situation0001", [
      
            "getUserId",
            "getContractId",
            "getThemeBrowsing",
            "getServiceLinkageInfo"
        ])
    },
    methods: {
        // Methods for dynamically add or remove input textbox
        addNew(index) {                
            var newMediaArray = {};
            var labelindex = index + 2;
            var label = '媒体名' + labelindex;
            newMediaArray.label = label;
            newMediaArray.name = "";
            this.mediaNameForm.items.push(newMediaArray);
        },
        removeNew(index) {
            this.mediaNameForm.items.splice(index, 1);
            var arrremove =[]
            for(var i =0; i<this.mediaNameForm.items.length;i++){
                var label = '媒体名' + (i+1)
                var newMediaArray = {};
                newMediaArray.label = label;
                newMediaArray.name = this.mediaNameForm.items[i].name;
                arrremove.push(newMediaArray);
            }
            this.mediaNameForm.items = arrremove;
        },
        editFormAdd(index) {  
            var editMediaArray= {};
            var labelindex = index + 2;
            var label = '媒体名' + labelindex;
            editMediaArray.label = label;
            editMediaArray.name = "";
            this.getmediaNameForm.items.push(editMediaArray);
        },
        editFormRemove(index) {
            this.getmediaNameForm.items.splice(index, 1);
            var arrremoveEdit =[]
            for(var i =0; i<this.getmediaNameForm.items.length;i++){
                var label = '媒体名' + (i+1)
                var editMediaArray = {};
                editMediaArray.label = label;
                editMediaArray.name = this.getmediaNameForm.items[i].name;
                arrremoveEdit.push(editMediaArray);
            }
            this.getmediaNameForm.items = arrremoveEdit;
        },
        register(formName){
            this.$LogButtonEvent("0012","Register");
			this.$LogMethodIN("0012","open");
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.$refs['mediaNameForm'].validate((valid) => {
                        if (valid) {
                            // 2023/03/27  #14161  START
                            this.Buttonpressed= 1;
                            // 2023/03/27  #14161  END
                            var ddArray = [];
                            if(this.mediaNameForm.items != undefined){
                                for (var i=0;i < this.mediaNameForm.items.length;i++){
                                    var addMediaArray = [];
                                    addMediaArray= this.mediaNameForm.items[i].name;
                                    if(addMediaArray != '')
                                    {
                                        ddArray.push(addMediaArray);
                                    }
                                }
                            }

                            var ddArray2 = [];
                            if(this.getmediaNameForm.items != undefined){
                                for (var j=0;j < this.getmediaNameForm.items.length;j++){
                                    var editMediaArray = [];
                                    editMediaArray= this.getmediaNameForm.items[j].name;
                                    if(editMediaArray != '')
                                    {
                                        ddArray2.push(editMediaArray);
                                    }
                                }
                            }
                            if(this.showtitle == 1){
                                var newRegisteration;
                                if(this.input2 != '')
                                {
                                    if(this.input3 != '')
                                    {
                                        if(this.name != '')
                                        {
                                            newRegisteration = {
                                                contract_id:this.contractId,
                                                user_id:this.userId,
                                                title: this.formitem.input1,
                                                keyword1: this.form.input2,  
                                                keyword2: this.form.input3,
                                                operator: this.showoperator,
                                                media_operator:this.showmediaoperator,
                                                process_kbn :1,
                                                media_name_list:ddArray
                                            };
                                        }
                                        else {
                                            newRegisteration = {
                                                contract_id:this.contractId,
                                                user_id:this.userId,
                                                title: this.formitem.input1,
                                                keyword1: this.form.input2,  
                                                keyword2: this.form.input3,
                                                operator: this.showoperator,
                                                process_kbn :1,
                                                media_operator:this.showmediaoperator
                                            };
                                        }
                                    } else{
                                        if(this.name != '')
                                        {
                                            newRegisteration = {
                                                contract_id:this.contractId,
                                                user_id:this.userId,
                                                title: this.formitem.input1,
                                                keyword1: this.form.input2,  
                                                operator: this.showoperator,
                                                media_operator:this.showmediaoperator,
                                                process_kbn :1,
                                                media_name_list:ddArray
                                            };
                                        }
                                        else {
                                            newRegisteration = {
                                                contract_id:this.contractId,
                                                user_id:this.userId,
                                                title: this.formitem.input1,
                                                keyword1: this.form.input2,  
                                                operator: this.showoperator,
                                                process_kbn :1,
                                                media_operator:this.showmediaoperator
                                            };
                                        }
                                    }
                                } 
                                else{
                                    if(this.input3 != '')
                                    {
                                        if(this.name != '')
                                        {
                                            newRegisteration = {
                                                contract_id:this.contractId,
                                                user_id:this.userId,
                                                title: this.formitem.input1,  
                                                keyword2: this.form.input3,
                                                operator: this.showoperator,
                                                media_operator:this.showmediaoperator,
                                                process_kbn :1,
                                                media_name_list:ddArray
                                            };
                                        }
                                        else {
                                            newRegisteration = {
                                                contract_id:this.contractId,
                                                user_id:this.userId,
                                                title: this.formitem.input1,
                                                keyword2: this.form.input3,
                                                operator: this.showoperator,
                                                process_kbn :1,
                                                media_operator:this.showmediaoperator
                                            };
                                        }
                                    } else{
                                        if(this.name != '')
                                        {
                                            newRegisteration = {
                                                contract_id:this.contractId,
                                                user_id:this.userId,
                                                title: this.formitem.input1,
                                                operator: this.showoperator,
                                                media_operator:this.showmediaoperator,
                                                process_kbn :1,
                                                media_name_list:ddArray
                                            };
                                        }
                                        else {
                                            newRegisteration = {
                                                contract_id:this.contractId,
                                                user_id:this.userId,
                                                title: this.formitem.input1,
                                                operator: this.showoperator,
                                                process_kbn :1,
                                                media_operator:this.showmediaoperator
                                            };
                                        }
                                    }
                                }

                                this.$store.dispatch('communication0012/registerForm',newRegisteration).then(() => {
                                    var status = this.getregisterform
                                    if(status == 0){
                                        this.$alert(this.getmessageDetail,  json["0012_register_success_title"], {
                                        confirmButtonText: 'OK',
                                        }).then(() => {
                                        router.push({name:"0011"});
                                        })
                                        // 2023/03/27  #14161  START
                                        this.Buttonpressed= 0;
                                        // 2023/03/27  #14161  END
                                    }
                                    else if(this.getmessagecode == "ERR0008"){
                                        this.$alert("入力された検索条件タイトルは既に登録されています。", json["0012_register_failure_title"], {
                                        confirmButtonText: 'OK'
                                        });
                                        // 2023/03/27  #14161  START
                                        this.Buttonpressed= 0;
                                        // 2023/03/27  #14161  END
                                    }
                                    else {
                                        this.$alert(this.getmessageDetail, json["0012_register_failure_title"], {
                                            confirmButtonText: 'OK'
                                        });
                                        // 2023/03/27  #14161  START
                                        this.Buttonpressed= 0;
                                        // 2023/03/27  #14161  END
                                    }
                                })
                            } else{
                                if(this.input2 != '')
                                {
                                    if(this.input3 != '')
                                    {
                                        if(this.value != '')
                                        {
                                            newRegisteration = {
                                                contract_id:this.contractId,
                                                user_id:this.userId,
                                                title: this.formitem.input1,
                                                keyword1: this.form.input2,  
                                                keyword2: this.form.input3,
                                                operator: this.showoperator,
                                                media_operator:this.showmediaoperator,
                                                process_kbn :2,
                                                media_name_list:ddArray2
                                            };
                                        }
                                        else {
                                            newRegisteration = {
                                                contract_id:this.contractId,
                                                user_id:this.userId,
                                                title: this.formitem.input1,
                                                keyword1: this.form.input2,  
                                                keyword2: this.form.input3,
                                                operator: this.showoperator,
                                                process_kbn :2,
                                                media_operator:this.showmediaoperator
                                            };
                                        }
                                    } else{
                                        if(this.value != '')
                                        {
                                            newRegisteration = {
                                                contract_id:this.contractId,
                                                user_id:this.userId,
                                                title: this.formitem.input1,
                                                keyword1: this.form.input2,  
                                                operator: this.showoperator,
                                                media_operator:this.showmediaoperator,
                                                process_kbn :2,
                                                media_name_list:ddArray2
                                            };
                                        }
                                        else {
                                            newRegisteration = {
                                                contract_id:this.contractId,
                                                user_id:this.userId,
                                                title: this.formitem.input1,
                                                keyword1: this.form.input2,  
                                                operator: this.showoperator,
                                                process_kbn :2,
                                                media_operator:this.showmediaoperator
                                            };
                                        }
                                    }
                                } 
                                else{
                                    if(this.input3 != '')
                                    {
                                        if(this.value != '')
                                        {
                                            newRegisteration = {
                                                contract_id:this.contractId,
                                                user_id:this.userId,
                                                title: this.formitem.input1,  
                                                keyword2: this.form.input3,
                                                operator: this.showoperator,
                                                media_operator:this.showmediaoperator,
                                                process_kbn :2,
                                                media_name_list:ddArray2
                                            };
                                        }
                                        else {
                                            newRegisteration = {
                                                contract_id:this.contractId,
                                                user_id:this.userId,
                                                title: this.formitem.input1,
                                                keyword2: this.form.input3,
                                                operator: this.showoperator,
                                                process_kbn :2,
                                                media_operator:this.showmediaoperator
                                            };
                                        }
                                    } else{
                                        if(this.value != '')
                                        {
                                            newRegisteration = {
                                                contract_id:this.contractId,
                                                user_id:this.userId,
                                                title: this.formitem.input1,
                                                operator: this.showoperator,
                                                media_operator:this.showmediaoperator,
                                                process_kbn :2,
                                                media_name_list:ddArray2
                                            };
                                        }
                                        else {
                                            newRegisteration = {
                                                contract_id:this.contractId,
                                                user_id:this.userId,
                                                title: this.formitem.input1,
                                                operator: this.showoperator,
                                                process_kbn :2,
                                                media_operator:this.showmediaoperator
                                            };
                                        }
                                    }
                                }
                                this.$store.dispatch('communication0012/registerForm',newRegisteration).then(() => {
                                    var status = this.getregisterform
                                    if(status == 0){
                                        this.$alert(json["0012_update_success_message"],  json["0012_update_success_title"], {
                                            confirmButtonText: 'OK',
                                        }).then(() => {
                                            router.push({name:"0011"});
                                        })
                                        // 2023/03/27  #14161  START
                                        this.Buttonpressed= 0;
                                        // 2023/03/27  #14161  END
                                    } else {
                                        this.$alert(this.getmessageDetail, json["0012_update_failure_title"], {
                                            confirmButtonText: 'OK'
                                        });
                                        // 2023/03/27  #14161  START
                                        this.Buttonpressed= 0;
                                        // 2023/03/27  #14161  END
                                    }
                                })
                            }
                        }
                        else {
                            return false;
                        }
                    });
                } 
                else {
                    return false;
                }
            });
            this.$LogMethodOut("0012","open");
        },
        // Button click method for input textbox clear
        clear_input (formName,formName1) {
            this.$LogButtonEvent("0012","TrialSearch");
			this.$LogMethodIN("0012","clear_input");
            var ddArray = [];
            // while search from the edit media name list
            if(this.getmediaNameForm.items != undefined){
                    
                for (var i=0;i < this.getmediaNameForm.items.length;i++){
                    var ddArray1 = [];
                    ddArray1= this.getmediaNameForm.items[i].name;
                    if(ddArray1 != '')
                    {
                        ddArray.push(ddArray1);
                    }
                }

            }
            // while search from the Add meadia name list
            else{
                
                for (var j=0;j < this.mediaNameForm.items.length;j++){
                    var addMediaArray = [];
                    addMediaArray= this.mediaNameForm.items[j].name;
                    if(addMediaArray != '')
                    {
                        ddArray.push(addMediaArray);
                    }
                    
                }
                
            }

            var service_linkage_info=this.service_linkage_info;
            var array=[];
            var Service=[];
            if(service_linkage_info != undefined && service_linkage_info != ""){
                for(var g=0; g<service_linkage_info.length; g++){
                    array = service_linkage_info[g];
                    delete array.csv_output_flag;
                    Service.push(array)
                }
            }

            var titleRow = {
                title: this.formitem.input1,
                keyword1: this.form.input2,  
                keyword2: this.form.input3,
                operator: this.showoperator,
                media_operator:this.showmediaoperator,
                media_name_list:ddArray,
                theme_browsing:this.theme_browsing,
                service_linkage_info: Service
            };
            Vue.prototype.$session.set('data', JSON.stringify(titleRow));
            this.$refs[formName].validate((valid) => {
                this.$refs[formName1].validate((valid1) => {
                if (valid) {
                    if (valid1) {
                    let routeData = this.$router.resolve({name: '0013', query: titleRow});
                    window.open(routeData.href, '_blank');
                }
            }
            })
            });
            this.$LogMethodOut("0012","clear_input");
        },
        gotoback(){  
            this.$LogButtonEvent("0012","Return");
			this.$LogMethodIN("0012","gotoback");
            router.push({name:"0011"});
            this.$LogMethodOut("0012","gotoback");
        },
        handleChange($event){
            this.showoperator = parseInt($event);
        },
        handleChange1($event){
            this.showmediaoperator = parseInt($event);
        }
    },
    //called after all the DOM elements has been mounted
    mounted() {
        //get the user id value from session
        this.userId = this.getUserId

        //get the contract_id value from session
        this.contractId = this.getContractId

        //get the theme_browsing value from session
        this.theme_browsing = this.getThemeBrowsing

        this.service_linkage_info = this.getServiceLinkageInfo

        if(this.$route.params.editToken == undefined || this.$route.params.editToken == "" || this.$route.params.editToken == null || this.$route.params.editToken == "null"){
            this.showtitle = 1;
            this.showoperator =1;
            this.showmediaoperator = 1;
        }
        else {
            this.showtitle = 0;
            this.formitem.input1 = this.gettitle;
            this.form.input2 = this.getkeyword;
            this.form.input3 =  this.getkeywordTwo;
           
            if(this.getoperator==1){
                    this.form.value1 = 'AND';
                    this.showoperator = this.getoperator;
            }else if(this.getoperator==2){
                this.form.value1 = 'OR';
                this.showoperator = this.getoperator;
            }else if(this.getoperator==3){
                this.form.value1 = 'NOT';  
                this.showoperator = this.getoperator;
            }
            if(this.getmediaOperator==1){
                this.form.value2 = 'AND';
                this.showmediaoperator = this.getmediaOperator;
            }else if(this.getmediaOperator==2){
                this.form.value2 = 'OR';
                this.showmediaoperator = this.getmediaOperator;
            }else if(this.getmediaOperator==3){
                this.form.value2 = 'NOT';
                this.showmediaoperator = this.getmediaOperator;
            }
        }
    },
    created() {
        //For the screen Title
        document.title = "記事閲覧";
    }
}
</script>
<style scoped>
@import "0012.css";
</style>
